import { AxiosPromise } from "axios";
import { axiosInstance } from "../instance";
import {
  ProjectsRequest,
  ProjectsResponse,
  ProjectResponse,
  ProjectRequest,
  ProjectCreateRequest,
  ProjectCreateResponse,
  ProjectUpdateRequest,
  ProjectUpdateResponse,
} from "./types";
import { Project } from "../../model/projects";

const defaultProjectViewExpand: Array<keyof Omit<Project, "id" | "inn" | "name">> = [
  "customer",
  "status",
  "responsible_user",
  "created_at",
  "created_by",
  "comments",
  "description",
  "activities",
  "legal_entity",
  "project_format",
  "contact",
  "bitrix_project_link",
  "bitrix_contract_link",
  "start_at",
  "planned_end_at",
  "can_edit",
  "can_remove",
];

export const projects = (data?: ProjectsRequest): AxiosPromise<ProjectsResponse> => {
  const { limit, offset, search, sort_column, sort_direction, ...rest } = data?.params?.filters || {};
  return axiosInstance.get(`/projects?expand=${data?.params?.expand?.join(",")}`, {
    params: {
      limit,
      offset,
      search,
      sort_column,
      sort_direction,
      ...rest,
    },
  });
};

export const projectView = (data: ProjectRequest): AxiosPromise<ProjectResponse> =>
  axiosInstance.get(`/project/${data.id}/view?expand=${data?.params?.expand?.join(",") || defaultProjectViewExpand.join(",")}`);

export const projectCreate = (params: ProjectCreateRequest): AxiosPromise<ProjectCreateResponse> => axiosInstance.post(`/project/create`, params);

export const updateProject = (data: ProjectUpdateRequest): AxiosPromise<ProjectUpdateResponse> =>
  axiosInstance.post(`/project/${data.id}/update`, data.body);

export const deleteProject = (id: number): AxiosPromise<undefined> => axiosInstance.post(`/project/${id}/delete`);
